// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3bgRa","fadeoutHeader":"Header_fadeoutHeader__2EYUE"};